import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Package, Plus, Search, ArrowUp, ArrowDown, Circle,
  Cable, Tag, ChevronRight,
} from 'lucide-react';
import {
  equipements, fournisseurs,
  formatMontant,
} from '../data/mockData';

const typeColors = {
  Materiel: 'info',
  Prestation: 'warn',
  Licence: 'sky',
};

const renderSens = (sens) => {
  if (sens === 'amont') return <span className="badge badge-sky"><ArrowUp size={12} /> Amont</span>;
  if (sens === 'aval') return <span className="badge badge-info"><ArrowDown size={12} /> Aval</span>;
  return <span className="badge badge-neutral"><Circle size={10} /> Passif</span>;
};

const Equipements = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('tous');

  const filtered = equipements.filter((eq) => {
    const matchSearch =
      eq.libelle.toLowerCase().includes(search.toLowerCase()) ||
      eq.marque.toLowerCase().includes(search.toLowerCase()) ||
      eq.modele.toLowerCase().includes(search.toLowerCase());
    const matchType = typeFilter === 'tous' || eq.type === typeFilter;
    return matchSearch && matchType;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Equipements</h1>
          <p className="page-subtitle">Bibliotheque des equipements references - Materiel / Prestation / Licence</p>
        </div>
        <button className="btn-primary">
          <Plus size={16} /> Nouvel equipement
        </button>
      </div>

      <div className="toolbar">
        <div className="search-input grow">
          <Search size={16} />
          <input
            placeholder="Rechercher par libelle, marque ou modele"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="seg-control">
          {['tous', 'Materiel', 'Prestation', 'Licence'].map((t) => (
            <button
              key={t}
              className={typeFilter === t ? 'active' : ''}
              onClick={() => setTypeFilter(t)}
            >
              {t === 'tous' ? 'Tous' : t}
            </button>
          ))}
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <table className="data-table clickable">
            <thead>
              <tr>
                <th>Equipement</th>
                <th>Type</th>
                <th>Marque / Modele</th>
                <th>Fournisseurs</th>
                <th>Handles</th>
                <th>Amont / Aval</th>
                <th style={{ textAlign: 'right' }}>Prix indicatif</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((eq) => {
                const premierRef = eq.references[0];
                return (
                  <tr
                    key={eq.id}
                    className="hoverable clickable"
                    onClick={() => navigate(`/equipements/${eq.id}`)}
                  >
                    <td>
                      <div className="cell-strong">
                        <Package size={16} className="cell-icon" />
                        <div>
                          <p>{eq.libelle}</p>
                          <span className="meta-line mono">{eq.id}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className={`badge badge-${typeColors[eq.type]}`}>
                        <Tag size={11} /> {eq.type}
                      </span>
                    </td>
                    <td>
                      <span className="mono">{eq.marque} / {eq.modele}</span>
                    </td>
                    <td>
                      {eq.references.map((r) => {
                        const f = fournisseurs.find((x) => x.id === r.fournisseurId);
                        return (
                          <span key={r.fournisseurId} className="chip">
                            {f?.nom || r.fournisseurId}
                          </span>
                        );
                      })}
                    </td>
                    <td>
                      <span className="chip chip-sky">
                        <Cable size={11} /> Synopt. {eq.handles.synoptique}
                      </span>
                      <span className="chip chip-sky">
                        <Cable size={11} /> Detail. {eq.handles.detaille}
                      </span>
                    </td>
                    <td>{renderSens(eq.sens)}</td>
                    <td style={{ textAlign: 'right' }}>
                      {premierRef ? formatMontant(premierRef.prixAchat) : '-'}
                    </td>
                    <td style={{ width: 28 }}>
                      <ChevronRight size={16} className="arrow-muted" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {filtered.length === 0 && (
            <div className="empty-state">
              <Package size={28} />
              <p>Aucun equipement ne correspond a votre recherche.</p>
            </div>
          )}
        </div>
      </div>

      <p className="meta-line" style={{ marginTop: '1rem' }}>
        {filtered.length} equipement(s) affiche(s). Cliquez sur une ligne pour consulter la fiche complete.
      </p>
    </div>
  );
};

export default Equipements;
